var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6485 13.2513C22.5424 7.72012 18.7831 2.51161 13.252 1.61775C7.72086 0.723877 2.51236 4.48313 1.61849 10.0143C0.724624 15.5454 4.48387 20.7539 10.015 21.6478C15.5462 22.5417 20.7547 18.7824 21.6485 13.2513Z",
    fill: "url(#paint0_linear_6808_8846)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85247 26.984L5.7995 25.1558C5.68709 25.05 5.54144 24.9864 5.38741 24.976L2.84742 24.7662C2.80372 24.7618 2.76169 24.747 2.72481 24.7232C2.68793 24.6993 2.65725 24.667 2.6353 24.629C2.61335 24.5909 2.60075 24.5482 2.59855 24.5043C2.59635 24.4604 2.60461 24.4167 2.62264 24.3766L6.24905 16.1348L11.9209 18.6373L8.28704 26.8791C8.27024 26.9193 8.24422 26.9549 8.21109 26.9832C8.17796 27.0114 8.13864 27.0314 8.09632 27.0417C8.054 27.0519 8.00988 27.052 7.96751 27.042C7.92515 27.032 7.88573 27.0121 7.85247 26.984Z",
    fill: "url(#paint1_linear_6808_8846)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.42 26.984L17.4729 25.1558C17.5853 25.05 17.731 24.9864 17.885 24.976L20.425 24.7662C20.4687 24.7618 20.5107 24.747 20.5476 24.7232C20.5845 24.6993 20.6152 24.667 20.6371 24.629C20.6591 24.5909 20.6717 24.5482 20.6739 24.5043C20.6761 24.4604 20.6678 24.4167 20.6498 24.3766L17.0234 16.1348L11.3515 18.6373L14.9854 26.8791C15.0022 26.9193 15.0282 26.9549 15.0614 26.9832C15.0945 27.0114 15.1338 27.0314 15.1761 27.0417C15.2184 27.0519 15.2626 27.052 15.3049 27.042C15.3473 27.032 15.3867 27.0121 15.42 26.984Z",
    fill: "url(#paint2_linear_6808_8846)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0076 13.8358C22.2228 8.65909 19.0113 3.47751 13.8346 2.26238C8.65794 1.04725 3.47636 4.25871 2.26123 9.43539C1.04609 14.6121 4.25756 19.7937 9.43424 21.0088C14.6109 22.2239 19.7925 19.0124 21.0076 13.8358Z",
    fill: "url(#paint3_linear_6808_8846)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4643 13.2464C19.3517 9.47199 17.0113 5.69285 13.2368 4.80548C9.46238 3.91811 5.68325 6.25853 4.79588 10.033C3.9085 13.8074 6.24893 17.5865 10.0234 18.4739C13.7978 19.3613 17.5769 17.0209 18.4643 13.2464Z",
    fill: "url(#paint4_linear_6808_8846)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96785 11.9842C4.9643 10.6167 5.36103 9.2781 6.10913 8.13341C6.85723 6.98872 7.92398 6.088 9.17785 5.54232C10.4317 4.99664 11.8179 4.82986 13.1654 5.06253C14.5129 5.29521 15.7629 5.91718 16.7612 6.85174C16.1088 6.20136 15.3348 5.68583 14.4832 5.3346C13.6316 4.98337 12.7192 4.8033 11.798 4.8047C10.8768 4.80609 9.96493 4.98891 9.11441 5.34271C8.26389 5.69651 7.49138 6.21438 6.841 6.86673C6.19061 7.51908 5.67509 8.29314 5.32385 9.14473C4.97262 9.99632 4.79256 10.9087 4.79395 11.8299C4.79534 12.7511 4.97816 13.663 5.33197 14.5135C5.68577 15.364 6.20363 16.1365 6.85598 16.7869C5.6371 15.4854 4.96166 13.7673 4.96785 11.9842Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6362 4.61882H11.4564C12.7588 4.65151 14.0231 5.06544 15.0927 5.80939C16.1623 6.55333 16.9902 7.59461 17.474 8.80432C17.9577 10.014 18.0761 11.3391 17.8145 12.6154C17.5528 13.8917 16.9226 15.0633 16.0018 15.985C15.0811 16.9068 13.9102 17.5383 12.6342 17.8013C11.3581 18.0644 10.033 17.9475 8.82274 17.465C7.6125 16.9826 6.57031 16.1558 5.82519 15.087C5.08008 14.0183 4.66476 12.7545 4.63064 11.4521C4.62695 11.5094 4.62695 11.567 4.63064 11.6244C4.62916 13.0132 5.03964 14.3713 5.81017 15.5268C6.5807 16.6823 7.67664 17.5834 8.95935 18.1159C10.2421 18.6484 11.6539 18.7885 13.0162 18.5184C14.3786 18.2484 15.6302 17.5804 16.6128 16.5988C17.5954 15.6173 18.2648 14.3663 18.5363 13.0043C18.8078 11.6422 18.6692 10.2302 18.138 8.94696C17.6069 7.66369 16.7071 6.56679 15.5524 5.79503C14.3977 5.02327 13.04 4.61133 11.6512 4.61133L11.6362 4.61882Z",
    fill: "#591706"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.742 11.1376C10.8809 11.1497 11.0289 11.1497 11.1859 11.1376C11.3429 11.1256 11.4878 11.0924 11.6207 11.038C11.7596 10.9776 11.8713 10.8931 11.9558 10.7844C12.0464 10.6757 12.0917 10.5307 12.0917 10.3496C12.0917 10.0778 12.0011 9.86946 11.82 9.72452C11.6388 9.57958 11.4305 9.50711 11.1949 9.50711C10.8688 9.50711 10.6212 9.61582 10.4521 9.83322C10.2891 10.0446 10.2106 10.3133 10.2166 10.6394H8.99371C9.00578 10.3133 9.06315 10.0174 9.16582 9.75169C9.27452 9.47994 9.42248 9.24744 9.60969 9.05419C9.80293 8.86094 10.0324 8.71298 10.2981 8.61032C10.5639 8.50162 10.8598 8.44727 11.1859 8.44727C11.4395 8.44727 11.6931 8.48652 11.9468 8.56503C12.2004 8.63749 12.4269 8.74922 12.6262 8.90019C12.8315 9.05117 12.9976 9.23536 13.1244 9.45276C13.2512 9.67017 13.3146 9.92079 13.3146 10.2046C13.3146 10.5126 13.2391 10.7844 13.0882 11.0199C12.9432 11.2554 12.7228 11.4154 12.4269 11.5V11.5181C12.7772 11.5966 13.0519 11.7657 13.2512 12.0254C13.4505 12.2851 13.5501 12.5961 13.5501 12.9584C13.5501 13.2906 13.4837 13.5865 13.3509 13.8462C13.224 14.1058 13.0519 14.3232 12.8345 14.4984C12.6171 14.6735 12.3665 14.8064 12.0827 14.8969C11.7988 14.9875 11.5029 15.0328 11.1949 15.0328C10.8386 15.0328 10.5125 14.9815 10.2166 14.8788C9.92673 14.7762 9.67913 14.6282 9.47381 14.435C9.26848 14.2357 9.10845 13.9941 8.99371 13.7103C8.885 13.4264 8.83367 13.1003 8.83971 12.732H10.0626C10.0687 12.901 10.0958 13.0641 10.1441 13.2211C10.1925 13.3721 10.2619 13.5049 10.3525 13.6197C10.4431 13.7284 10.5548 13.816 10.6877 13.8824C10.8265 13.9488 10.9896 13.982 11.1768 13.982C11.4667 13.982 11.7113 13.8945 11.9106 13.7193C12.1098 13.5382 12.2095 13.2936 12.2095 12.9856C12.2095 12.744 12.1612 12.5598 12.0645 12.433C11.974 12.3062 11.8562 12.2156 11.7113 12.1613C11.5663 12.1009 11.4063 12.0677 11.2312 12.0616C11.0621 12.0495 10.899 12.0435 10.742 12.0435V11.1376Z",
    fill: "#591706"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6808_8846",
    x1: 3.1268,
    y1: 3.11902,
    x2: 18.6964,
    y2: 18.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6808_8846",
    x1: 5.90439,
    y1: 24.3167,
    x2: 7.59772,
    y2: 20.8476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6808_8846",
    x1: 17.1208,
    y1: 24.2642,
    x2: 15.5773,
    y2: 20.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6808_8846",
    x1: 20.4744,
    y1: 20.4702,
    x2: 4.53767,
    y2: 4.53344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6808_8846",
    x1: 17.7458,
    y1: 17.7497,
    x2: 2.64829,
    y2: 2.65211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronzeMedal.5f5bafc6fcdc1531fba084e0b681eb11.svg";
export { ForwardRef as ReactComponent };